import "./App.css";
import React from "react";
import axios from 'axios';
import { Accordion, Button, Icon, Popup } from "semantic-ui-react";
import Tour from "reactour";

import CollectionCreate from "./components/CollectionCreate";
import CollectionUpload from "./components/CollectionUpload";
import CollectionsList from "./components/CollectionsList";
import Configuration from "./components/Configuration";
import ConfigurationUpdate from "./components/ConfigurationUpdate";
import Geocoder from "./components/Geocoder";
import Login from "./components/Login";
import MapPanel from "./components/MapPanel";
import FeaturesList from "./components/FeaturesList";
import ProcessesList from "./components/ProcessesList";
import Settings from "./components/Settings";
import StatusMessage from "./components/StatusMessage";
import StyleEditor from "./components/StyleEditor";

import vanu from "./apis/vanu";
import VanuLogo from "./images/vanu-purple.png";


const getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
};


class App extends React.Component {

    constructor(props) {
        super(props);

        var token = getCookie("vanu_token");
        var is_anonymous = token ? false : true;

        this.state = {
            token: getCookie("vanu_token"),
            username: getCookie("vanu_user"),
            is_anonymous: is_anonymous,
            activeAccordionIndex: 0,
            errorMessage: "",
            configuration: null,
            collections: [],
            selectedCollection: null,
            selectedVersion: null,
            profile: null,
            processes: [],
            activeProcess: null,
            statusMsgId: 0,
            statusMsg: "Welcome to VanuMaps!",
            statusMsgType: "info",
            displayColorPicker: false,
            zoomAt: [null, null],
            isTourOpen: false,
            sites: null,
            cover_ranges: null,
            map_options: null
        };

        // default cover_ranges (for GSM)
        this.state.cover_ranges = [
            { "color": { "b": 0, "g": 255, "r": 0 }, "interval": [-65, 0] },
            { "color": { "b": 0, "g": 255, "r": 255 }, "interval": [-75, -65] },
            { "color": { "b": 0, "g": 120, "r": 255 }, "interval": [-85, -75] },
            { "color": { "b": 0, "g": 0, "r": 255 }, "interval": [-100, -85] }
        ];
        // defaut map options
        this.state.map_options = {
            "sites": { "color": { "a": 1, "b": 255, "g": 0, "r": 0 }, "display_labels": true },
            "processes": { "opacity": 70 }
        };
    }

    onLogin = (token, username) => {
        this.setState({
            token: token,
            username: username,
            is_anonymous: false,
            isTourOpen: true,
        });
        this.init();
    };

    onLogout = () => {
        document.cookie = "vanu_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        document.cookie = "vanu_user=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        this.setState({
            token: null,
            username: null,
            is_anonymous: true,
        });
        this.updateStatusBar("Please login to use VanuMaps!", "warning");
        this.init();
    };

    updateStatusBar = (statusMsg, statusMsgType) => {
        this.setState({
            statusMsg: statusMsg,
            statusMsgType: statusMsgType,
            statusMsgId: this.state.statusMsgId + 1,
        });
    };

    init = () => {
        if (this.state.username) {
            this.setProfile(this.state.username);
            this.loadCollections();
            this.updateStatusBar(
                `Welcome to the VanuMaps dashboard, ${this.state.username}.`,
                "info"
            );
            // TODO we need to select first collection
        } else {
            this.updateStatusBar("Please login to use VanuMaps!", "warning");
        }
    };

    setProfile = async (username) => {
        const response = await vanu.get(`/profiles/${username}`, {
            headers: { Authorization: "Token " + this.state.token },
        });
        this.setState({
            profile: response.data,
        });
        this.onConfigurationChange(response.data.active_configuration);
    };

    refreshSelectedVersion = async () => {
        const response = await vanu.get(`/collectionversions/${this.state.selectedVersion.pk}`, {
            headers: { Authorization: "Token " + this.state.token },
        });
        this.setState({
            selectedVersion: response.data
        });

    }

    loadCollections = async (page = 1) => {
        const url = `/collections/?page=${page}`;
        const response = await vanu.get(url, {
            headers: { Authorization: "Token " + this.state.token },
        });

        if (response.data.results.length > 0) {
            this.setState({
                collections: response.data.results,
                collectionsCount: response.data.count,
            });
            this.onCollectionChange(this.state.collections[0].pk);
        } else {
            this.updateStatusBar("Please upload or create a new collection to start using the dashboard!", "warning");
        }
    };

    onConfigurationChange = async (conf_id) => {
        const response = await vanu.get(`/configurations/${conf_id}/`, {
            headers: { Authorization: "Token " + this.state.token },
        });
        this.setState({
            isLoaded: true,
            configuration: response.data
        });
    };

    onCollectionChange = async (collection_pk, defaultToMasterVersion = true) => {
        const response = await vanu.get(`/collections/${collection_pk}`, {
            headers: { Authorization: "Token " + this.state.token },
        });

        this.loadProcesses(collection_pk);

        this.setState({
            selectedCollection: response.data,
        });
        if (defaultToMasterVersion) {
            const master_version = response.data.master_version;
            this.loadSites(master_version.pk);
            this.setState(
                {
                    selectedVersion: master_version,
                }
            )
        }
    };

    uploadCollection = async (event) => {
        var formData = new FormData();
        var collection_name = event.target.collection_name.value;
        if (event.target.csv_file && event.target.csv_file.files.length) {
            formData.append("csv_file", event.target.csv_file.files[0]);
        }
        formData.append("name", collection_name);

        try {
            await vanu.post("/collections/", formData, {
                headers: {
                    Authorization: "Token " + this.state.token,
                    "Content-Type": "multipart/form-data",
                },
            });
            // check response here to see if there are errors
            this.loadCollections();
            this.updateStatusBar(
                `Collection "${collection_name}" was succesfully created.`,
                "info"
            );
        } catch (err) {
            let msg = err;
            if (err.response.data && err.response.data.detail) {
                msg = err.response.data.detail;
            }
            this.updateStatusBar(
                `Could not create collection "${collection_name}". Error was: ${msg}.`,
                "error"
            );
        }
    };

    removeCollection = async (event) => {
        await vanu.delete(`/collections/${this.state.selectedCollection.pk}`, {
            headers: {
                Authorization: "Token " + this.state.token,
                "Content-Type": "multipart/form-data",
            },
        });
        this.updateStatusBar(
            `Collection "${this.state.selectedCollection.name}" was succesfully removed.`,
            "success"
        );
        this.setState({
            selectedCollection: null
        }
        )
        this.loadCollections();
    };

    updateConfiguration = async (event) => {
        // save from ConfigurationUpdate
        event.preventDefault();
        // add bool variable to detect when cover ranges are changed
        var cover_ranges_changed = false;
        console.log(
        'radioAntennaType.value type:', typeof event.target.radioAntennaType.value,
        'radioAntennaType.value:', event.target.radioAntennaType.value,
        'ant_type type:', typeof this.state.configuration.ant_type,
        'ant_type:', this.state.configuration.ant_type
        );
        // if LTE is selected change cover ranges to ones meant for LTE
        if (event.target.radioAntennaType.value === '2' && this.state.configuration.ant_type !== 2) {
            console.log("changing cover ranges to LTE ones");
            this.setState({ cover_ranges: [
                { "color": { "b": 0, "g": 255, "r": 0 }, "interval": [-85, 0] },
                { "color": { "b": 0, "g": 255, "r": 255 }, "interval": [-95, -85] },
                { "color": { "b": 0, "g": 120, "r": 255 }, "interval": [-105, -95] },
                { "color": { "b": 0, "g": 0, "r": 255 }, "interval": [-120, -105] }
            ] });
            cover_ranges_changed = true;
        };
        // if UMTS is selected change cover ranges to ones meant for UMTS
        if (event.target.radioAntennaType.value === '1' && this.state.configuration.ant_type !== 1) {
            console.log("changing cover ranges to UMTS");
            this.setState({ cover_ranges: [
                { "color": { "b": 0, "g": 255, "r": 0 }, "interval": [-65, 0] },
                { "color": { "b": 0, "g": 255, "r": 255 }, "interval": [-75, -65] },
                { "color": { "b": 0, "g": 120, "r": 255 }, "interval": [-85, -75] },
                { "color": { "b": 0, "g": 0, "r": 255 }, "interval": [-100, -85] }
            ] });
            cover_ranges_changed = true;
        };
        // if GSM is selected change cover ranges to ones meant for GSM
        if (event.target.radioAntennaType.value === '0' && this.state.configuration.ant_type !== 0) {
            console.log("changing cover ranges to GSM");
            this.setState({ cover_ranges: [
                { "color": { "b": 0, "g": 255, "r": 0 }, "interval": [-65, 0] },
                { "color": { "b": 0, "g": 255, "r": 255 }, "interval": [-75, -65] },
                { "color": { "b": 0, "g": 120, "r": 255 }, "interval": [-85, -75] },
                { "color": { "b": 0, "g": 0, "r": 255 }, "interval": [-100, -85] }
            ] });
            cover_ranges_changed = true;
        };

        let data = {
            ant_gain: event.target.ant_gain.value,
            bts_ht: event.target.bts_ht.value,
            bts_ht_override: event.target.bts_ht_override.checked,
            fr: event.target.fr.value,
            txpwr: event.target.txpwr.value,
            txpwr_override: event.target.txpwr_override.checked,
            is_sector: event.target.is_sector.checked,
            max_range: event.target.max_range.value,
            buffer_distance: event.target.buffer_distance.value,
            ant_type: event.target.radioAntennaType.value,
            allocated_cpich: event.target.allocated_cpich.value,
            channel_bandwidth: event.target.radioChannelBandwidth.value,
            cover_ranges: this.state.cover_ranges,
            map_options: this.state.map_options
        };
        try {
            const response = await vanu.post("/configurations/", data, {
                headers: { Authorization: "Token " + this.state.token },
            });
            this.setState({ configuration: response.data });


            const coverRangesList = this.state.cover_ranges.map(range =>
                `${range.interval[0]}`
            ).join(', ');

            if (cover_ranges_changed) {
                this.updateStatusBar(
                    `Configuration updated successfully. Antenna type was changed and cover ranges are reset to: ${coverRangesList}`,
                    "success"
                );
            } else {
                this.updateStatusBar(
                    `Configuration updated successfully. Cover ranges: ${coverRangesList}`,
                    "success"
                );
            }
        } catch (err) {
            this.updateStatusBar(`Could not change configuration.`, 'error');
        }
    };

    updateProfile = async (data) => {
        try {
            const response = await vanu.put(`/profiles/${this.state.username}/`, data, {
                headers: { Authorization: "Token " + this.state.token },
            });

            this.setState({ profile: response.data });
            // we have to reload configuration to update locals
            this.onConfigurationChange(response.data.active_configuration);
            // we need to update units if there is a selected version
            if (this.state.selectedVersion) {
                this.refreshSelectedVersion();
            }
            this.updateStatusBar(`User settings were changed.`, "success");
        } catch (err) {
            this.updateStatusBar(`Could not change user settings.`, 'error');
        }
    };

    componentDidMount() {
        this.init();
    }

    displayProcess = (proc) => {
        this.loadSites(proc.collection_version.pk);
        if (proc !== this.state.activeProcess)
            this.setState({
                activeProcess: proc,
                selectedVersion: proc.collection_version,
            });
        else {
            this.setState({
                activeProcess: null,
                selectedVersion: this.state.selectedCollection.master_version,
            });
        }
    };

    loadSites = async (collection_version_pk, page = 1) => {
        const response = await vanu.get(`/sites/?collection_version=${collection_version_pk}&page=${page}`, {
            headers: { Authorization: "Token " + this.state.token },
        });
        this.setState({
            sites: response.data.results,
        });
        console.log(this.state.sites);
    }

    setActiveFeature = (feature_id) => {
        this.setState({ activeFeature: feature_id });
    };

    editingCompleted = (
        site,
        selectedVersion,
        msg = "Editing was performed, refreshing map panel..."
    ) => {
        if (site) {
            this.onCollectionChange(this.state.selectedCollection.pk);
            this.setState({
                selectedVersion: selectedVersion,
            });
        } else {
            this.updateStatusBar(msg, "error");
        }
    };

    saveFeature = (event, sector_nodes) => {
        event.preventDefault();

        // process azimuths
        let azimuths = [];
        let is_sector = event.target.is_sector.checked;
        if (is_sector) {
            for (let i = 0; i < sector_nodes; i++) {
                azimuths.push(event.target[`input_sector_${i}`].value);
            }
        }

        const commonData = {
            collection_version: this.state.selectedVersion.pk,
            height: event.target.feat_height.value,
            txpwr: event.target.feat_txpwr.value,
            is_sector: event.target.is_sector.checked,
            sector_nodes: sector_nodes,
            azimuths: azimuths.sort()
        }

        if (event.target.apply_all.checked) {
            this.saveAllFeatures(commonData);
        } else {
            const data = {
                pk: event.target.feat_pk.value,
                geom: event.target.feat_geom.value,
                name: event.target.feat_name.value,
                ...commonData
            };
            this.saveOneFeature(data)
        }
    };

    saveOneFeature = async (data) => {
        try {
            await vanu.put(`/sites/${data.pk}/`, data, {
                headers: { Authorization: "Token " + this.state.token },
            });
            this.updateStatusBar(`Site "${data.name}" was succesfully updated.`, 'info');
            this.onCollectionChange(this.state.selectedCollection.pk);
            this.setActiveFeature(data.pk);
        } catch (err) {
            this.updateStatusBar(`Could not update site "${data.name}" because of an error.`, 'error');
        }
    }

    saveAllFeatures = async (commonData) => {
        this.state.selectedVersion.sites.forEach(site => {
            const data = {
                pk: site.pk,
                geom: site.geom,
                name: site.name,
                ...commonData
            }
            this.saveOneFeature(data);
        })
        this.updateStatusBar(`All sites for collection have been updated.`, 'info');
        this.onCollectionChange(this.state.selectedCollection);
    }

    removeFeature = async (site) => {
        await vanu.delete(`/sites/${site.pk}`, {
            headers: { Authorization: "Token " + this.state.token },
        });

        // TODO set an activefeature when deleting one
        this.setState({ activeFeature: null });
        this.onCollectionChange(this.state.selectedCollection.pk);
    };

    removeFeatures = () => {
        this.state.selectedCollection.master_version.sites.forEach((site) => {
            this.removeFeature(site);
        });
        this.updateStatusBar(
            `All sites for site "${this.state.selectedCollection.name}" removed.`,
            "success"
        );
    };

    delay = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms))
    }

    loadProcesses = async (collection_pk, page = 1) => {
        const response = await vanu.get(`/processruns/?collection=${collection_pk}&page=${page}`, {
            headers: { Authorization: "Token " + this.state.token },
        });
        this.setState({
            processes: response.data.results,
            processesCount: response.data.count,
        });
    }

    refreshProcess = async (process_id) => {
        let processed = false;
        while (!processed) {
            const response = await vanu.get(`/processruns/${process_id}`, {
                headers: { Authorization: "Token " + this.state.token },
            });
            if (response.data.status > 0) {
                if (response.data.status === 2) {
                    this.updateStatusBar(
                        `Process ${response.data.uuid} for collection "${this.state.selectedCollection.name}" raised an error.`,
                        "error"
                    );
                    processed = true;
                } else {
                    if (response.data.populationcounterprocess.status === 1){
                        this.updateStatusBar(
                            `Population for collection "${this.state.selectedCollection.name}" successfully calculated.`,
                            "success"
                        );
                        processed = true;
                    }
                    this.updateStatusBar(
                        `Process ${response.data.uuid} for collection "${this.state.selectedCollection.name}" successfully completed.`,
                        "success"
                    );
                    this.loadSites(response.data.collection_version.pk);
                    this.setState({
                        activeProcess: response.data,
                        selectedVersion: response.data.collection_version,
                    });
                }
            }
            this.setState({
                runningProcess: response.data
            });
            await this.delay(2000);
        }
        this.onCollectionChange(this.state.selectedCollection.pk, false);
    };

    runProcess = async () => {
        this.updateStatusBar(
            `Process for collection "${this.state.selectedCollection.name}" started.`,
            "info"
        );
        let data = {
            collection: this.state.selectedCollection.pk,
        };
        const response = await vanu.post("/processruns/", data, {
            headers: { Authorization: "Token " + this.state.token },
        });
        this.refreshProcess(response.data.pk);
        this.onCollectionChange(this.state.selectedCollection.pk, false);
    };

    removeProcess = async (proc_url) => {
        await axios({
            url: proc_url,
            method: 'delete',
            headers: { Authorization: "Token " + this.state.token }
        })
        this.updateStatusBar(
            `Process ${proc_url} for collection "${this.state.selectedCollection.name}" removed.`,
            "success"
        );
        this.onCollectionChange(this.state.selectedCollection.pk);
    };

    removeProcesses = () => {
        this.state.selectedCollection.processes.forEach((proc_url) => {
            this.removeProcess(proc_url);
        });
        this.updateStatusBar(
            `All processers for site "${this.state.selectedCollection.name}" removed.`,
            "success"
        );
    };

    handleAccordionClick = (e, titleProps) => {
        const { index } = titleProps;
        const { activeAccordionIndex } = this.state;
        const newIndex = activeAccordionIndex === index ? -1 : index;

        this.setState({ activeAccordionIndex: newIndex });
    };

    onGeocodeSearch = (coords) => {
        let zoomAt = coords.split(",");
        this.setState({ zoomAt: zoomAt });
    };

    openTour = () => {
        this.setState({ isTourOpen: true });
    };

    closeTour = () => {
        this.setState({ isTourOpen: false });
    };

    processTourStep = (step) => {
        if (step === 1) {
            // TODO this is causing a but, we should make the main sections as components
            // this.setState({ activeAccordionIndex: 1 });
        }
    };

    saveMapProperties = async (coverRanges, unsavedMapOptions) => {
        // save from StyleEditor
        // convert it to this.setState
        this.setState({ cover_ranges: coverRanges, map_options: unsavedMapOptions });
        this.state.configuration.cover_ranges = coverRanges;
        this.state.configuration.map_options = unsavedMapOptions;

        console.log("this.state.configuration");
        console.log(this.state.configuration);
        let data = {
            ...this.state.configuration,
            cover_ranges: coverRanges,
            map_options: unsavedMapOptions
        };
        try {
            const response = await vanu.post("/configurations/", data, {
                headers: { Authorization: "Token " + this.state.token },
            });
            this.setState({
                configuration: response.data
            });
            this.updateStatusBar(`Configuration for map properties was changed.`, "success");
        } catch (err) {
            this.updateStatusBar(`Could not change configuration to map properties.`, 'error');
        }
    };

    render() {

        const tourConfig = [
            {
                // 0
                selector: '[data-tut="reactour__welcome"]',
                content: `Welcome to the VanuMaps app. Using this dashboard you will be able to model possible configurations for a collection of sites/antennas and find best solutions to maximize radio coverage`,
            },
            {
                // 1
                selector: '[data-tut="reactour__collections"]',
                content: `In this section you can select the active collection. You can also upload a sites collection from a file or you can create one from scratch`,
            },
            {
                // 2
                selector: '[data-tut="reactour__collections__create"]',
                content: `You can click on this button to create a new collection of sites/antennas`,
            },
            {
                // 3
                selector: '[data-tut="reactour__collections__upload"]',
                content: `You can click on this button to upload a .csv file as a new collection of sites/antennas`,
            },
            {
                // 4
                selector: '[data-tut="reactour__configuration"]',
                content: `Here you can see and change the configuration parameters used by the processes runner of the dashboard (for example: antenna gain, height, frequency, transmit power and many others)`,
            },
            {
                // 5
                selector: '[data-tut="reactour__sites"]',
                content: `In this section you can see the sites attributes for the active collection. You can also edit or remove existing sites`,
            },
            {
                selector: '[data-tut="reactour__processes"]',
                content: `In this section you can run a process for the active collection using the current configuration. You can also display processes ran previously`,
            },
            {
                selector: '[data-tut="reactour__mapproperties"]',
                content: `In this section you can set map properties such as the process layer transparency and the sites/antennas color`,
            },
            {
                selector: '[data-tut="reactour__map"]',
                content: `In the map panel you can view your currently selected sites collection, processes. You can zoom and pan in the map, and change the base layer using the layer switcher`,
            },
            {
                selector: '[data-tut="reactour__map__edit"]',
                content: `You can click on this button to add a new site to the active sites collection`,
            },
            {
                selector: '[data-tut="reactour__map__select"]',
                content: `You can click on this button to select a site in the map and check its attributes in the "Sites" section`,
            },
            {
                selector: '[data-tut="reactour__layerswitcher"]',
                content: `You can use the layer switcher to show/hide the antennas and their processes, and to change base map`,
            },
            {
                selector: '[data-tut="reactour__geocoder"]',
                content: `You can search a place by typing the place name or by inserting its coordinates (lon, lat)`,
            },
            {
                selector: '[data-tut="reactour__help"]',
                content: `You can access to the user guide of the dashboard or again to this guided tour of the dashboard by using these buttons`,
            },
        ];

        return (
            <>
                <div className="ui container">
                    <div className="ui grid">
                        <div className="ui row">
                            <h2 className="ui image header" data-tut="reactour__welcome">
                                <img
                                    src={VanuLogo}
                                    className="image"
                                    alt="Welcome to VanuMaps Dashboard"
                                />
                                <div className="content">VanuMaps Dashboard</div>
                            </h2>
                        </div>
                        <div className="ui row">
                            <StatusMessage
                                key={this.state.statusMsgId}
                                content={this.state.statusMsg}
                                msgType={this.state.statusMsgType}
                            />
                        </div>
                        <div className="ui row">
                            <div className="five wide column"></div>
                            <div className="six wide column">
                                <Login logged={this.state.is_anonymous} onLogin={this.onLogin} />
                            </div>
                        </div>
                        <div className="ui row">
                            <div className="six wide column">
                                <div className="ui segment" hidden={this.state.is_anonymous}>
                                    <div>
                                        <div data-tut="reactour__help">
                                            Welcome, {this.state.username}
                    .&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button
                                                id='btn-logout'
                                                icon
                                                onClick={this.onLogout}
                                                className="ui small button"
                                                data-tooltip="Logout from the dashboard"
                                                data-inverted=""
                                            >
                                                <Icon name="sign-out" />
                                            </Button>
                                            <Button
                                                icon
                                                onClick={this.openTour}
                                                className="ui small button"
                                                data-tooltip="Guided tour of the dashboard"
                                                data-inverted=""
                                            >
                                                <Icon name="bus" />
                                            </Button>
                                            <a href="/help">
                                                <Button
                                                    icon
                                                    data-tooltip="User guide of the dashboard"
                                                    data-inverted=""
                                                >
                                                    <Icon name="help" />
                                                </Button>
                                            </a>
                                        </div>
                                    </div>

                                    <div className="ui vertical segment">
                                        <Accordion fluid styled hidden={this.state.is_anonymous}>
                                            <Accordion.Title
                                                active={this.state.activeAccordionIndex === 0}
                                                index={0}
                                                onClick={this.handleAccordionClick}
                                            >
                                                <Popup
                                                    content="In this section you can select the active collection. You can also upload a 
                          sites collection from a file or you can create one from scratch."
                                                    position="top left"
                                                    inverted
                                                    trigger={
                                                        <div data-tooltip="test">
                                                            <Icon name="map" />
                                                            <Icon name="dropdown" />
                            Collections
                          </div>
                                                    }
                                                />
                                            </Accordion.Title>
                                            <Accordion.Content
                                                active={this.state.activeAccordionIndex === 0}
                                                data-tut="reactour__collections"
                                            >
                                                <div className="ui vertical segment">
                                                    <CollectionCreate
                                                        handleSubmit={this.uploadCollection}
                                                    />
                                                    <CollectionUpload
                                                        handleSubmit={this.uploadCollection}
                                                    />
                                                    <Button
                                                        icon
                                                        onClick={this.removeCollection}
                                                        data-tooltip="Remove the active sites-collection"
                                                        data-inverted=""
                                                    >
                                                        <Icon name="delete" />
                                                    </Button>
                                                </div>
                                                <div className="ui vertical segment">
                                                    <CollectionsList
                                                        onCollectionChange={this.onCollectionChange}
                                                        collections={this.state.collections}
                                                        selectedCollection={this.state.selectedCollection}
                                                        onPageChange={this.loadCollections}
                                                        collectionsCount={this.state.collectionsCount}
                                                    />

                                                    <div>
                                                        {this.state.selectedCollection
                                                            ? `Active collection: ${this.state.selectedCollection.name}`
                                                            : "Please upload or create a new collection to start using the dashboard!"}
                                                    </div>
                                                    <div>
                                                        {this.state.selectedVersion
                                                            ? `Version: ${this.state.selectedVersion.number} (${this.state.selectedVersion.sites.length} sites)`
                                                            : ""}
                                                    </div>
                                                </div>
                                            </Accordion.Content>

                                            <Accordion.Title
                                                active={this.state.activeAccordionIndex === 1}
                                                index={1}
                                                onClick={this.handleAccordionClick}
                                                data-tut="reactour__configuration"
                                            >
                                                <Popup
                                                    content="In this section you can change the configuration parameters used by the processes 
                          runner of the dashboard (for example: antenna gain, height, frequency, transmit power 
                          and many others)."
                                                    position="top left"
                                                    inverted
                                                    trigger={
                                                        <div>
                                                            <Icon name="setting" />
                                                            <Icon name="dropdown" />
                            Configuration
                          </div>
                                                    }
                                                />
                                            </Accordion.Title>
                                            <Accordion.Content
                                                active={this.state.activeAccordionIndex === 1}
                                            >
                                                Current Configuration:
                      <Configuration
                                                    configuration={this.state.configuration}
                                                    profile={this.state.profile}
                                                />
                                                {this.state.configuration
                                                    ?
                                                    <div className="ui vertical segment">
                                                        <ConfigurationUpdate
                                                            configuration={this.state.configuration}
                                                            profile={this.state.profile}
                                                            handleSubmit={this.updateConfiguration}
                                                        />
                                                    </div>
                                                    : <div></div>
                                                }
                                            </Accordion.Content>

                                            <Accordion.Title
                                                active={this.state.activeAccordionIndex === 2}
                                                index={2}
                                                onClick={this.handleAccordionClick}
                                                data-tut="reactour__sites"
                                            >
                                                <Popup
                                                    content="In this section you can look at the sites (antennas) for the active sites
                        collection. Furthermore, you can edit them (change name, height etc...) in the case
                        you have not processes generated for this collection."
                                                    position="top left"
                                                    inverted
                                                    trigger={
                                                        <div>
                                                            <Icon name="map marker" />
                                                            <Icon name="dropdown" />
                            Sites
                          </div>
                                                    }
                                                />
                                            </Accordion.Title>
                                            <Accordion.Content
                                                active={this.state.activeAccordionIndex === 2}
                                            >

                                                {this.state.profile
                                                    ?
                                                    <FeaturesList
                                                        selectedVersion={this.state.selectedVersion}
                                                        sites={this.state.sites}
                                                        activeFeature={this.state.activeFeature}
                                                        activeProcess={this.state.activeProcess}
                                                        onPageChange={this.loadSites}
                                                        onSetActiveFeature={this.setActiveFeature}
                                                        onRemoveFeature={this.removeFeature}
                                                        onRemoveFeatures={this.removeFeatures}
                                                        onSaveFeature={this.saveFeature}
                                                        profile={this.state.profile}
                                                        configuration={this.state.configuration}
                                                    />
                                                    : <div></div>
                                                }

                                            </Accordion.Content>

                                            <Accordion.Title
                                                active={this.state.activeAccordionIndex === 3}
                                                index={3}
                                                onClick={this.handleAccordionClick}
                                                data-tut="reactour__processes"
                                            >
                                                <Popup
                                                    content="In this section you can run a process  or looking at 
                          previously generated processes for the active sites collection."
                                                    position="top left"
                                                    inverted
                                                    trigger={
                                                        <div>
                                                            <Icon name="users" />
                                                            <Icon name="dropdown" />
                            Processes
                          </div>
                                                    }
                                                />
                                            </Accordion.Title>
                                            <Accordion.Content
                                                active={this.state.activeAccordionIndex === 3}
                                            >
                                                <div className="ui vertical segment">
                                                    <ProcessesList
                                                        processes={this.state.processes}
                                                        processesCount={this.state.processesCount}
                                                        profile={this.state.profile}
                                                        activeProcess={this.state.activeProcess}
                                                        onDisplayClick={this.displayProcess}
                                                        onPageChange={this.loadProcesses}
                                                        onRemoveProcess={this.removeProcess}
                                                        onRemoveProcesses={this.removeProcesses}
                                                        onRunProcess={this.runProcess}
                                                        refreshProcess={this.refreshProcess}
                                                        runningProcess={this.state.runningProcess}
                                                        selectedCollection={this.state.selectedCollection}
                                                        sites={this.state.sites}
                                                    />
                                                </div>
                                            </Accordion.Content>

                                            <Accordion.Title
                                                active={this.state.activeAccordionIndex === 4}
                                                index={4}
                                                onClick={this.handleAccordionClick}
                                                data-tut="reactour__mapproperties"
                                            >
                                                <Popup
                                                    content="In this section you can change map properties such as the cover map opacity or the sites
                        color style"
                                                    position="top left"
                                                    inverted
                                                    trigger={
                                                        <div>
                                                            <Icon name="globe" />
                                                            <Icon name="dropdown" />
                            Map Properties
                          </div>
                                                    }
                                                />
                                            </Accordion.Title>

                                            <Accordion.Content
                                                active={this.state.activeAccordionIndex === 4}
                                            >
                                                {this.state.configuration
                                                    ?
                                                    <StyleEditor
                                                        configuration={this.state.configuration}
                                                        onSaveMapProperties={this.saveMapProperties}
                                                    />
                                                    : <div></div>
                                                }
                                            </Accordion.Content>

                                            <Accordion.Title
                                                active={this.state.activeAccordionIndex === 5}
                                                index={5}
                                                onClick={this.handleAccordionClick}
                                                data-tut="reactour__mapproperties"
                                            >
                                                <Popup
                                                    content="In this section you can change settings such an the units used for power, length..."
                                                    position="top left"
                                                    inverted
                                                    trigger={
                                                        <div>
                                                            <Icon name="user" />
                                                            <Icon name="dropdown" />
                            Settings
                          </div>
                                                    }
                                                />
                                            </Accordion.Title>

                                            <Accordion.Content
                                                active={this.state.activeAccordionIndex === 5}
                                            >
                                                {this.state.profile
                                                    ?
                                                    <Settings
                                                        profile={this.state.profile}
                                                        onSaveProfile={this.updateProfile}
                                                    />
                                                    : <div></div>
                                                }
                                            </Accordion.Content>

                                        </Accordion>
                                    </div>
                                </div>
                            </div>

                            <div className="ten wide column" hidden={this.state.is_anonymous}>
                                <MapPanel
                                    selectedVersion={this.state.selectedVersion}
                                    activeProcess={this.state.activeProcess}
                                    activeFeature={this.state.activeFeature}
                                    configuration={this.state.configuration}
                                    onSetActiveFeature={this.setActiveFeature}
                                    onEditingCompleted={this.editingCompleted}
                                    token={this.state.token}
                                    zoomAt={this.state.zoomAt}
                                />
                                <Geocoder onGeocodeSearch={this.onGeocodeSearch} />
                            </div>
                        </div>
                    </div>
                </div>

                <Tour
                    getCurrentStep={this.processTourStep}
                    steps={tourConfig}
                    isOpen={this.state.isTourOpen}
                    onRequestClose={this.closeTour}
                />

            </>
        );
    }
}

export default App;
